<template>
  <div class="home">
    <div class="head-box">
      <headPage :active="headActive"/>
    </div>
    <div class="main">
      <div class="content-view">
        <router-view @setActive="getActive"></router-view>
      </div>
    </div>
    <div class="foot-box">
      <footPage/>
    </div>
  </div>
</template>
<script>
import headPage from "@/views/home/common/headPage";
import footPage from "@/views/home/common/footPage";

export default {
  name: "home",
  data() {
    return {
      headActive: ''
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {
    headPage,
    footPage
  },
  created() {

  },
  methods: {
    getActive(data) {
      if (data) {
        this.headActive = data.headActive
      }
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.home {
  width: 100%;
  height: max-content;
  min-height: 100vh;

  .head-box {
    width: 100%;
  }

  .main {
    width: 100%;
    min-height: calc(100vh - (173px + 153px));
  }

  .foot-box {
    width: 100%;
  }
}
</style>


